

const checkHours = (hours, timezone) => {
    return true;
};
export default checkHours;